<template>
    <div class="testimonials block-contained">
      <div class="row">
        <div class="col-md-6 m-b-lg">
          <h3 class="block-title">
            Testimonials
          </h3>
          <blockquote>
            <p>We have always been able to purchase exactly what we have needed at a competitive price, and if it was a specialty
              job, they will help to engineer it for you.</p>
          </blockquote>
          <blockquote>
            <p>Trustworthy and friendly service that understands the importance of keeping a business going.</p>
          </blockquote>
          <blockquote>
            <p>Iowa Spring make a quality garage door spring and I appreciate the personal service I get. Having a few of my
              biggest movers pre-made to expedite orders is a huge convenience.</p>
          </blockquote>
          <blockquote>
            <p>Doing business with Iowa Spring is like a mutually beneficial partnership.</p>
          </blockquote>
          <blockquote>
            <p>With the diversity of sizes being so great in the way we handle our wholesale business, accuracy must be insisted
              on if we are to continue in a relationship with a manufacturer. Iowa Spring has lived up to their promise of
              delivering a quality product, accurately, and timely.</p>
          </blockquote>
        </div>
        <!--Latest Blog posts-->
        <div class="col-md-6 blog-roll padding-top-60">
          <div class="media">
            <div class="media-body">
                  <img src="../assets/img/misc/Springs-about-us-1.jpg" alt="fork lift" class="img-responsive img-thumbnail m-b hidden-xs">
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "HomePageTestimonials"
};
</script>



// WEBPACK FOOTER //
// src/components/HomePageTestimonials.vue